import { render, staticRenderFns } from "./MenuPart.vue?vue&type=template&id=c31373f8"
import script from "./MenuPart.vue?vue&type=script&lang=js"
export * from "./MenuPart.vue?vue&type=script&lang=js"
import style0 from "./MenuPart.vue?vue&type=style&index=0&id=c31373f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports